import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParametrosGenericos } from 'src/app/models/bas/parametros-genericos/parametros-genericos';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ParametrosGenericosService extends AbstractIdbaService {

  override model: ParametrosGenericos;

  constructor(http: HttpClient) { 
    super(http, new ParametrosGenericos());
    this.programName = "cad/genericos/pargenerico.p";
  }

  pesquisarPorNumero(codigoModulo: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-pesquisa-parametros-genericos-por-numero";
    request.parameters = { codigoModulo };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  pesquisarPorCodigo(codigoParGenerico: number) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-pesquisa-codigo-parametros-genericos";
    request.parameters = { codigoParGenerico };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  pesquisarPorModuloAssunto(modulo: string, assunto: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-listar-modulo-assunto";
    request.parameters = { modulo, assunto };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }


}
